import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IEndClientMast } from "../../models/EndClientMast";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyEndClient } from "./EmptyEndClient";
import { JVDropdown } from "../../shared/JVDropdown";
import { IIndustryMastDropdown } from "../../models/IDropdown";

const schema = yup.object({
    end_Client_Name: yup.string().required("End Client is required*"),
    Linkendin:yup.string().url("please enter the linkendin url")
});

interface Iprops {
    singleData: IEndClientMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {

    const [Industry, setIndustry] = useState<Array<IIndustryMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IEndClientMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const loadIndsutry = async () => {
        const response = await Fetch("Dropdown/industries", "GET",null, null, null);
        if (response) {
            const data: Array<IIndustryMastDropdown> = await response.json();
           
            setIndustry(data);
        }
    }

    useEffect(() => {
        loadIndsutry();
        reset(props.singleData);
    }, [props.singleData])

    const saveToDB = async (body: IEndClientMast) => {
        const method = props.singleData.end_Client_Id ? "PUT" : "POST";
        const message = props.singleData.end_Client_Id ? "Updated Successfully" : "Added Successfully";
        delete body.industry_Name;
        const response = await Fetch("End_Client_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success',  detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyEndClient);
    }

    function onSubmit(data: IEndClientMast) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add End Client" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={2} required label="End Client Name " control={control} name="end_Client_Name" error={errors.end_Client_Name?.message}/>
                <JVDropdown column={2} required label="Industry Type" control={control} name="industry_Id"  options={Industry} optionLabel="industry_Name" optionValue="industry_Id" placeholder="Select Industry Type" />
                <JVInput column={1} required label="LinkedIn Url " control={control} name="linkendin" error={errors.linkendin?.message}/>
               
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}
